import { type AiAgentModel, resolveReasoningEffort } from "@ext/agent/llm/agentLlmModel";
import { useMemo } from "react";
import { useAgentChatHealthcheck } from "../store/AgentChatHealthcheckStore";
import { useActiveSessionSelectedModel } from "../store/AgentStore";

export type SelectedAgentModel = {
	model: AiAgentModel;
	reasoningEffort: string | undefined;
};

export const useSelectedAgentModel = (): SelectedAgentModel | null => {
	const { models } = useAgentChatHealthcheck();
	const storedModel = useActiveSessionSelectedModel();

	return useMemo(() => {
		const storedMatch = models?.find(
			(model) => model.type === storedModel?.type && model.name === storedModel?.name,
		);
		const model = storedMatch ?? models?.[0];
		if (!model) return null;
		return { model, reasoningEffort: resolveReasoningEffort(model, storedMatch && storedModel?.reasoningEffort) };
	}, [models, storedModel]);
};
